import React, { Component, Fragment } from 'react';

import { SalesContext } from '../../Context/SalesContext';

import {
  Back,
  Checkbox,
} from '../Common';

import { QuoteItem } from './Components';
import LteQuoteItem from './Components/LteQuoteItem/LteQuoteItem';

import {
  Subtitle,
} from "./../../StyledComponents";

import {
  submitSalesOrder,
} from "../../Services/Services";
import SubmitLeadRequestError from "./../Common/SubmitLeadRequestError/SubmitLeadRequestError";

import {
  tagOnQuotationPageLoad,
  tagOnRequestSubmitSuccess,
  tagOnTermsAndConditionCheckboxSelect
} from "../../Tagging/SalesTagging";

import {
  addBeforeloadEvent,
  removeBeforeloadEvent,
  getSelectedProductsArrays
} from "../../Utility/utility";

import './Quotation.css';

const TermsTexts = `
  I hereby acknowledge and accept that this quote is a valid and binding agreement in respect of the equipment 
  and/or service concluded between myself and Vodacom on the
`;

export default class Quotation extends Component {
  static contextType = SalesContext;
  miniAppProactiveSales = !!(window.isFtthMA);

  state = {
    termsAccepted: false,
    selectedServices: null,
    quoteTotals: {
      totalOnceOff: 0,
      totalRecurring: 0,
    },
    formSubmitAttempt: 0,
    hasError: false,
    termsAndConditionURL: "https://www.vodacom.co.za/vodacom/terms/fibre/vodacom-fibre",
  }
  
  agentUsername = sessionStorage.getItem('retailUserDetails') ? JSON.parse(sessionStorage.getItem('retailUserDetails')).username : null;

  updateTermsAndCondition(value) {
    this.setState({ termsAccepted: value });
    this.context.setTermsAccepted(value)
    if (value) {
      tagOnTermsAndConditionCheckboxSelect();
    }
  }

  resetError = () => {

    this.setState({
      hasError: false,
      formSubmitAttempt: 0
    });
  }

  errorResubmitClickHandler = () => {

    this.setState(prevState => {
      return {
        hasError: false,
        formSubmitAttempt: prevState.formSubmitAttempt + 1
      }
    });
  }

  submitSalesOrder = (_e) => {

    if (!!this.agentUsername) {

      this.context.setShowSpinner(false);
      this.props.history && this.props.history.push('/cloud/fibre/sales/CustomerApproval');

      return;
    }

    this.context.setShowSpinner(true);
    submitSalesOrder(this.context)
      .then((response) => {
        console.log(
          "[Quotation][submitSalesOrder][submitSalesOrder-Success]"
        );
          this.context.setUserDetails({
          key: "quoteNumber",
          value: response.result && response.result.quoteNumber,
        });
        // window.scrollTo(0, 0);
        this.context.setShowSpinner(false);

        const { taggingIdArray, taggingQtyArray, taggingPriceArray } = getSelectedProductsArrays(this.context.selectedPackage, this.context.selectedAdditionalServices, this.context.additionalServices);
        tagOnRequestSubmitSuccess(
          response.result && response.result.quoteNumber,
          'EC Order success',
          taggingIdArray, 
          taggingQtyArray, 
          taggingPriceArray,
          this.context.isUserExisting,
          this.context.userDetails.contactNumber
        );
        this.props.history.push("/cloud/fibre/sales/success");
      })
      .catch((error) => {
        console.error(
          "[Quotation][submitSalesOrder][submitSalesOrder-Failed]"
        );
        console.error(error);
        if (this.state.formSubmitAttempt <= 4) {
          this.setState((prevState) => {
            return {
              hasError: true,
              formSubmitAttempt: prevState.formSubmitAttempt + 1,
            };
          });
        } else {
          this.resetError();
          this.props.history.push("/cloud/fibre/sales/error");
        }
        this.context.setShowSpinner(false);
      });
  }

  openTermsAndConditionView = () => {

    this.props.history.push("/cloud/fibre/sales/extTermsAndConditionLink");

  }

  renderTerms = () => {

    const terms = (
      <Fragment>
        {TermsTexts}
        <a
          href={this.state.termsAndConditionURL}
          target="_blank"
          automationid={`SalesLead_Link_TermsAndConditionsLink_0`}
        >
          terms and conditions
        </a>
      </Fragment>
    );

    const miniAppTerms = (
      <Fragment>
        {TermsTexts}
        <span className='quote-terms-miniapp' onClick={this.openTermsAndConditionView}>
          terms and conditions
        </span>
      </Fragment>
    );

    return (
      <Checkbox
        onChange={(_e) => this.updateTermsAndCondition(!this.state.termsAccepted)}
        value={this.state.termsAccepted}
        label={!this.miniAppProactiveSales ? terms : miniAppTerms}
        automatioIdAttr={`TermsAndConditions`}
        checked={this.state.termsAccepted}
      />
    );
  }

  componentWillUnmount = () => {
    removeBeforeloadEvent();
  }


  componentDidMount() {
    addBeforeloadEvent();

    tagOnQuotationPageLoad();
    const selectedServices = [];
    const quoteTotals = {
      totalOnceOff: 0,
      totalRecurring: 0,
    };

    this.setState(
      {
        selectedServices,
        quoteTotals,
        termsAccepted: this.context.termsAccepted
      });
  }

  render() {

    const {
      selectedContractTerm,
      selectedPackage,
      userDetails,
      installationCost
    } = this.context;

    return (

      <div className='quote-wrapper'>
        {
          this.state.hasError
            ? <SubmitLeadRequestError
              reSubmit={this.errorResubmitClickHandler}
              close={this.resetError}
              automationidattr={`QuotationPage`}
            />
            : null
        }
        <div className='quote-content'>

          <h1 className='header page-header' automationid={`SalesLead_H1_QuotationHeading_0`}>Quotation</h1>

          <p className='quote-salutations' automationid={`SalesLead_P_QuotationSalutations_0`}>Dear {`${userDetails.firstName} ${userDetails.lastName}`}</p>
          <p automationid={`SalesLead_P_QuotationSAlutationsDesc_0`}>Thank you for your interest in our services. Please make sure you are happy with the below quote before submitting your order.</p>

          <Subtitle>
            Your order
          </Subtitle>

          <QuoteItem
            data={selectedPackage.dataCap}
            installationCost={`R${installationCost}`}
            monthlyCost={`R${selectedPackage.productPrice.value}`}
            name={this.context.selectedPackageType}
            onceOffCost={installationCost}
            period={this.context.selectedPackageType === "Vodacom One Deals" ? selectedContractTerm.contractTerm : selectedContractTerm.duration}
            contractTerm={this.context.selectedContractTerm}
          />

          {
            this.context.lteReviewData ? 
            <React.Fragment>
              <Subtitle>
                Additional services
              </Subtitle>
              <LteQuoteItem
                data={this.context.lteReviewData.size}
                monthlyCost={`${this.context.lteReviewData.price}`}
                name={this.context.lteReviewData.displayName}
                promotion={this.context.lteReviewData.promotion}
              />
            </React.Fragment>
            :
            null
          }

          <div className='quote-terms' automationid={`SalesLead_Div_QuoteTerms_0`}>
            {this.renderTerms()}
          </div>
        </div>

        <div>
          <Back
            buttonName="SUBMIT ORDER"
            enabledButton={this.state.termsAccepted}
            nextUrl="/cloud/fibre/sales/finalizeOrder"
            onNextClick={this.submitSalesOrder}
            automationidattr={`QuotationPage`}
            backUrl="/cloud/fibre/sales/employerDetails"
          />
        </div>
      </div>
    );
  }
}
